import { useQuery } from "@tanstack/react-query";
import { useAddons } from "./useAddons";
import { AddonCode } from "@growth-machine-llc/stridist-api-client";
import { TEAM_COACHES_QUERY_KEY } from "../routes/coach/team/CoachTeamRoute";
import TeamService from "../services/TeamService";
import { TeamRole } from "../constants";

export function useCoachSeatsCheck() {
  const { data: addons } = useAddons();

  const coachSeatsAddon = addons?.find(
    (addon) => addon.code === AddonCode.TEAM_ACCOUNT,
  );

  const { data: allActiveCoaches } = useQuery({
    queryKey: [TEAM_COACHES_QUERY_KEY],
    queryFn: () => TeamService.getCoaches(),
  });
  const usedSeats =
    allActiveCoaches?.filter((coach) => coach.teamRole === TeamRole.COACH)
      .length ?? 0;

  const availableSeats = coachSeatsAddon?.quantity ?? 0;

  const hasAvailableSeats = availableSeats > usedSeats;

  return {
    availableSeats,
    hasAvailableSeats,
  };
}

